import classNames from 'classnames'

import { Button } from 'core-components/library/button'
import { Flex } from 'core-components/library/flex'
import { applicationUpdating } from 'src/core/classes/services/InitializationServiceCore'
import SiteUpdateLayout from 'src/core/layout/SiteUpdateLayout'

import { getMessage } from './error/helpers/getMessage'

import styles from './Error.module.scss'

interface IProps {
  message?: string
  reloadPageButtonVisible?: boolean
  goToMainButtonVisible?: boolean
}

export const ViewError = (props: IProps) => {
  if (applicationUpdating) {
    return <SiteUpdateLayout />
  }

  return (
    <Flex alignItems={'center'} justifyContent={'center'} className={styles.root}>
      <Flex className={styles.card}>
        <Flex flexDirection={'column'} alignItems={'center'}>
          <i className={classNames(styles.icon, 'kbase kbase-warning-alt')} />
          <p className={styles.title}>{getMessage(props.message)}</p>
          <Flex justifyContent={'center'} className={'content-full-width'}>
            {props.reloadPageButtonVisible ? (
              <Button
                className={styles.button}
                variant={'contained'}
                onClick={() => {
                  window.location.reload()
                }}
              >
                Reload page
              </Button>
            ) : null}

            {props.goToMainButtonVisible !== false ? (
              <Button
                className={styles.button}
                variant={'contained'}
                onClick={() => {
                  window.location.replace('/')
                }}
              >
                Go to main page
              </Button>
            ) : null}
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  )
}
export default ViewError
